
jQuery(document).ready( init );

function init() {
  activateSlickSlider('.center');
  initLightCase();
  initfaqAccordion()
}

/**
 * Initializes Slick on Blog Posts Slider
 * @param {string} selector - CSS Selector
 */
function activateSlickSlider (selector) {
  $(selector).on('init', function() {
    $(this).show();
  });
  $(selector).slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });
}

/**
 * Initializes Slick on Destination Info Cards
 * @param {string} selector - CSS Selector
 */
function initDestinationSlick (selector) {

  var prevArrow = '<button type="button" class="slick-prev">'
                + '<img src="/wp-content/themes/cannabistours/assets/min/imgs/icons/chevron.svg" alt="">'
                + '</button>'
  var nextArrow = '<button type="button" class="slick-next">'
                + '<img src="/wp-content/themes/cannabistours/assets/min/imgs/icons/chevron.svg" alt="">'
                + '</button>'

  $(selector).slick({
    dots: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
}

// Inits lightcase
// http://cornel.bopp-art.com/lightcase/documentation/
function initLightCase() {
  jQuery('a[data-rel^=lightcase]').lightcase();
}

function initfaqAccordion () {
  
  if (document.body.classList.contains('page-template-destination-faq')) {
    const accItem = document.querySelectorAll('.accordionItem');
    const accHD = document.getElementsByClassName('accordionItemHeading');
  
    accItem.forEach( function(el) {
      el.addEventListener('click', toggleItem, false)
    });
    
    function toggleItem() {
      var openItems = this.parentElement.querySelectorAll('.accordionItem.open');
      var that = this;
      
      openItems.forEach( function (el) {
        if ( that.classList.contains('open') ) return;
        el.classList.remove('open');
      })
      
      this.classList.toggle('open');
    }
  }
}

